import Emitter from "./Emitter";

export default class GamePaused extends Emitter {
    constructor(gb) {
        super(gb);
    }

    POKERSTARS_handler() {
        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify({"msgId": "rg2xcGamePaused"}), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify({"msgId": "rg2xcGamePaused"}), "*");
        }
    }

    PLAYTECH_handler() {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('displaystatus')) {
            var interval = setInterval(() => {
                if (!this.gb.isSpinning) {
                    const data = {
                        "_type": "ucip.displaystatus.g2wUiStateNotification",
                        "busy": true
                    }
                    if (this.gb.settings.nativeMobileApp) {
                        data.handled = true;
                        window.parent.postMessage(JSON.stringify(data));
                    } else {
                        this.emitParent(JSON.stringify(data));
                    }

                    clearInterval(interval)

                    return
                }

            }, 150)
        }
    }

    _default() {
        this.emitTop({ wpgaction: "gamePaused" });
        this.emitParent({ wpgaction: "gamePaused.parent" });
        this.emitiOS({ wpgaction: "gamePaused" });
    }
}


